import WebFont from 'webfontloader'

WebFont.load({
  custom: {
    families: ['Grota Sans']
  }
})
